import BaseModalContainer, { type IModalContainerProps } from '@srm/ui/modal-container';
import FormProviderControl from '@controls/FormProviderControl';

export type { IModalContainerProps };

/** Окно пакета с формой Front: у полей окна своя область обработчиков `<changes>`. */
const ModalContainer = (props: IModalContainerProps) => (
    <BaseModalContainer formComponent={FormProviderControl} {...props} />
);

export default ModalContainer;
